module.exports = __webpack_public_path__ + "img/FR.0bf0a4d9.svg";